import { TypographyP2 } from '@heidi/design-system/typography';

const CHAR_STAGGER_MS = 45;
// Overrides animate-pulse's default 2s cycle via inline style (an inline
// longhand wins over a class) so the wave dims more gradually.
const PULSE_DURATION_MS = 3200;

interface ClinicalTaskAssigneeEmptyStatePromptProps {
  text: string;
}

// Uses Tailwind's built-in `animate-pulse` and starts each character a little
// later than the last, so the pulse reads as a wave travelling left to right
// instead of the whole line dimming in unison. `motion-reduce:animate-none`
// collapses every character back to the static string. The wave is
// `aria-hidden`; a `sr-only` span carries the real text so screen readers get
// one announcement instead of one per letter.
export function ClinicalTaskAssigneeEmptyStatePrompt({
  text,
}: ClinicalTaskAssigneeEmptyStatePromptProps) {
  return (
    <TypographyP2 className="text-text-tertiary">
      <span className="sr-only">{text}</span>
      <span aria-hidden>
        {[...text].map((char, index) => (
          <span
            key={index}
            className="inline-block animate-pulse motion-reduce:animate-none"
            style={{
              animationDelay: `${index * CHAR_STAGGER_MS}ms`,
              animationDuration: `${PULSE_DURATION_MS}ms`,
              animationFillMode: 'backwards',
            }}
          >
            {/* A plain " " inside its own inline-block collapses to zero width
                (CSS trims whitespace-only inline-block content), so spaces
                need a non-breaking space to stay visible between words. */}
            {char === ' ' ? '\u00A0' : char}
          </span>
        ))}
      </span>
    </TypographyP2>
  );
}
